import React from 'react';
import {Popup, Icon} from 'semantic-ui-react';
import PropTypes from 'prop-types';

const ClipLifetimeDescription = ({clipLifetime}) => (
    <Popup
        className='--text-left'
        content={`Leave this value empty if you want to use the clip lifetime value defined on 
            product level (${clipLifetime} minutes).`}
        hoverable
        position='right center'
        trigger={<Icon name='info circle' className='--marginLeft-50px' />}
        wide='very'
    />
);

ClipLifetimeDescription.propTypes = {
    clipLifetime: PropTypes.number,
};

export default ClipLifetimeDescription;
